// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-set-add {
  padding: 1rem;
  max-width: 800px;
  margin: 0 auto;
}

.add-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.add-header h1 {
  font-size: 1.3rem;
  margin: 0;
}

.mode-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.tab {
  flex: 1 1;
  padding: 1rem;
  border: 2px solid #e0e0e0;
  background: white;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.tab:hover {
  border-color: #2196F3;
}

.tab.active {
  border-color: #2196F3;
  background: #e3f2fd;
  color: #1976D2;
}

.lessons-browser {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.hint {
  color: #666;
  text-align: center;
  margin-bottom: 1rem;
}

.lesson-set-group h3 {
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
  color: #333;
}

.lessons-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.lesson-item-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.lesson-item-btn:hover {
  background: #f5f5f5;
  border-color: #2196F3;
}

.lesson-item-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.lesson-name {
  font-weight: 500;
}

.lesson-count {
  color: #666;
  font-size: 0.9rem;
}

/* Words selector */
.words-selector {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.words-header {
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
}

.words-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 60vh;
  overflow-y: auto;
}

.word-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.word-item:hover {
  border-color: #2196F3;
}

.word-item.selected {
  border-color: #4CAF50;
  background: #e8f5e9;
}

.word-item input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: #4CAF50;
}

.word-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.word-english {
  font-weight: 600;
}

.word-polish {
  color: #666;
  font-size: 0.9rem;
}

.word-type {
  font-size: 1.2rem;
}

.add-words-bar {
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.add-words-bar span {
  font-weight: 600;
}

.add-words-bar .btn {
  padding: 0.75rem 1.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/pages/CustomSetAdd.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".custom-set-add {\n  padding: 1rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.add-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.add-header h1 {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.mode-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.tab {\n  flex: 1;\n  padding: 1rem;\n  border: 2px solid #e0e0e0;\n  background: white;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.tab:hover {\n  border-color: #2196F3;\n}\n\n.tab.active {\n  border-color: #2196F3;\n  background: #e3f2fd;\n  color: #1976D2;\n}\n\n.lessons-browser {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.hint {\n  color: #666;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.lesson-set-group h3 {\n  font-size: 1.1rem;\n  margin-bottom: 0.75rem;\n  color: #333;\n}\n\n.lessons-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.lesson-item-btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.lesson-item-btn:hover {\n  background: #f5f5f5;\n  border-color: #2196F3;\n}\n\n.lesson-item-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.lesson-name {\n  font-weight: 500;\n}\n\n.lesson-count {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n/* Words selector */\n.words-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.words-header {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: space-between;\n}\n\n.words-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.word-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.word-item:hover {\n  border-color: #2196F3;\n}\n\n.word-item.selected {\n  border-color: #4CAF50;\n  background: #e8f5e9;\n}\n\n.word-item input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  accent-color: #4CAF50;\n}\n\n.word-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.word-english {\n  font-weight: 600;\n}\n\n.word-polish {\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.word-type {\n  font-size: 1.2rem;\n}\n\n.add-words-bar {\n  position: fixed;\n  bottom: 70px;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: white;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n}\n\n.add-words-bar span {\n  font-weight: 600;\n}\n\n.add-words-bar .btn {\n  padding: 0.75rem 1.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
